
import * as React from 'react';
import { apiRequest } from '@/utils/request';
import { useState } from 'react';

import { Form, PasswordSetup } from '@/components/business';
import { Button, Link } from '@/components/ui';

export function ResetPassword({ onAlert, code, backToLogin }) {
    const
        [loading, setLoading] = useState(false),
        [password, setPassword] = useState(''),
        [isValid, setIsValid] = useState(false);

    const handlePasswordChange = ({ password: nextPassword, isValid: nextIsValid }) => {
        setPassword(nextPassword);
        setIsValid(nextIsValid);
    };

    const onHandleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        const data = {
            password,
            password_confirmation: password
        };

        try {
            const response = await apiRequest(`/reset_password/${code}`, 'PUT', data);

            if (response.status === 200) {
                onAlert(i18next.t('ui.passwords.successfully_changed'), 'success', i18next.t('common.success'));
                backToLogin();
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 500);
        }
    };

    return (
        <div className="tw-grid tw-grid-cols-1 tw-gap-4">
            <Form onSubmit={onHandleSubmit}>
                <PasswordSetup onChange={handlePasswordChange} />
                <Button type="submit" loading={loading} fullWidth tone="secondary" disabled={!isValid}>
                    {i18next.t('ui.buttons.submit')}
                </Button>
            </Form>
            {/* Back to Login */}
            <Link icon="arrowLeftCircle" onClick={backToLogin} text={i18next.t('ui.passwords.back_to_login')} variant="body"/>
        </div>
    );
}
